module.exports = __webpack_public_path__ + "static/media/picnic.5c0d721f.jpg";